let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike','$rootScope'];

class CartService {
    constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike,$rootScope,) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.AuthTokenFactory = AuthTokenFactory;
        this.SharedService = SharedService;
        this.SessionService = SessionService;
        this.$rootScope = $rootScope,
        this.cart = {};
    }

    addItemToCart(product, quantity, addItemAlreadyInCart1, isModalFastLoad, userId, cart) {

        return this.$q((resolve, reject) => {
            let addItemAlreadyInCart = addItemAlreadyInCart1 || 0;
            // Se valida la cantidad en local
            if (isNaN(quantity) || quantity < 1) {
                return resolve({
                    error: true,
                    message: 'Para adicionar este producto al carrito de compras debe ingresar una cantidad valida.',
                    isHtml: false
                });
            }
            /* Declara la letiable itemCart */
            let itemCart = undefined;
            /* Si es definida la letiable global cart, recorre el arreglo de items adentro de la misma
            * y devuelve el objeto con la misma referencía en el carrito y el que se este agregando */
            if (cart) {
                itemCart = cart.items.filter(val => {
                    return val.reference === product.reference;
                })[0];
            }
            /* define la letiable itemCartQuantity => si itemCart esta definido, agrega la cantidad de ese item
            * en el carrito, Sino lo define en 0 */
            let itemCartQuantity = itemCart ? itemCart.quantity : 0;
            /* Define la letiable availableQuantity restando la cantidad del producto a comprar y la cantiadad del mismo
            * item en el carrito */
            let availableQuantity = parseInt(product.cantidad) - parseInt(itemCartQuantity);

            let cartId = cart.cartId ? cart.cartId : this.SessionService.get('cartId') || '';

            /* Si la cantidad disponible es negativa le indica a el usuario que hacer al respecto*/
            if (availableQuantity < 0) {

                // Funcion que actualiza la venta perdida
                //this.updateItemsNotAvailable(product, quantity, addItemAlreadyInCart1, userId, cart, availableQuantity);
                console.log('cart 2 ->'+cartId);
                this.updateItemsNotAvailable(product, quantity, userId, cartId);
                
                let mensaje = "<span>El producto <strong>" +
                    product.name +
                    "</strong>  tiene un excedente de <strong>" +
                    (availableQuantity * -1) +
                    "</strong> unidades en el carrito. Por favor elimine el excedente.</span>";
                return resolve({
                    error: true,
                    message: mensaje,
                    isHtml: true
                });
            }
            /* Si la cantidad a agregar del producto es mayor a la cantidad disponible del mismo le indica al usuario que hacer al respecto */
            // if (quantity > product.cantidad){
            if (quantity > availableQuantity) {
                // console.log("Cart Service quantity",quantity);
                // console.log("Cart Service product",product);
                // console.log("Cart Service availableQuantity",availableQuantity);
                console.log('cart 3 ->'+cartId);
                this.updateItemsNotAvailable(product, quantity, userId, cartId);
                let mensaje = "<span>Lo Sentimos, El producto <strong>" + product.name + "</strong>  no está disponible en la cantidad solicitada. La existencia actual de este producto es <strong>" + product.cantidad + "</strong> Unidades</span>";
                return resolve({
                    error: true,
                    message: mensaje,
                    isHtml: true
                });
            }
            let currentItemId = product.id;

            
            let productId = product.id;
            if (product.clonedId) {
                currentItemId = product.clonedId;
                productId = product.clonedId;
            }
            let data = {
                'id_canasta': cartId,
                'userId': userId,
                'id_producto': productId,
                'cantidad_producto': quantity,
                'comentario_producto': '',
                'addItemAlreadyInCart': addItemAlreadyInCart,
                'origen':"B2B"
            };
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.addItemToCart,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                if(!response.data.error){
                    this.SessionService.put('cartId', response.data.cartId);
                }
                if (response.data.agotado) {
                    product.cantidad = response.data.itemStock;
                    console.log('cart 4 ->'+cartId);
                    this.updateItemsNotAvailable(product, quantity, userId, cartId);
                }
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    addProductToCartNew(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/cart/agregar-item-canasta',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false,
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                if (!response.data.error) {
                    if (!data.id_canasta) {
                        this.saveCart(response.data.cartId);
                    }
                    resolve(response.data);
                } else {
                    reject(response.data.message);
                }

            }).catch(reason => {
                reject(reason);
            });
        });
    }

    saveCartOrderData(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.saveCartOrderData,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    locationBySearchText(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.locationBySearchText,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateCommentCart(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updateCommentCart,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updatePayMethod(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updatePayMethod,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateQuantityItemCart(data) {
      data.origen = "B2B";
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updateQuantityItemCart,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getPayMethods(sellerId, userId,sucursalId,cartId) {
        origin = 'b2b';
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.payMethods + '?sellerId=' + sellerId + '&userId=' + userId + '&origin=' + origin + '&sucursalId=' + sucursalId + '&cartId=' + cartId,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getPayConditions(userId,cartId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.payConditions + '?userId=' + userId+ '&cartId=' + cartId,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getPayConditionsChangeBranchOffice(userId,cartId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.payConditionsChangeBranchOffice + '?userId=' + userId+ '&cartId=' + cartId,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getPointsOfSale(sucursalId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getPointsOfSale + '?origin=B2B' + '&sucursal=' +sucursalId,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getInfoBillfoldState(thirdDocumentNumber, branchCode) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri2 + this.ngAuthSettings.config.paths.REPORTS.B2B.BILLFOLD_RESUME +
                '?terceroDocumentoNumero=' + thirdDocumentNumber +
                '&sucursalCodigo=' + branchCode,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    saveCart(cart) {
        let token = btoa(cart + ':' + new Date());
        this.AuthTokenFactory.setToken('auth-cart', token);
        this.cart = cart;
    }

    clearCart(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.deleteCart,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                this.cart = {};
                this.cart.cartQuantity = 0;
                this.cart.cartTaxes = 0;
                this.cart.cartSubtotal = 0;
                this.cart.cartTotal = 0;
                this.cart.cartDiscounts = 0;
                this.cart.cartTransports = 0;
                this.cart.items = [];
                this.cart.order = {};
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getCart(cartId, userId, clientPriceListName, clear, url, login) {

        return this.$q((resolve, reject) => {
            if (this.cart && this.cart.cartId && !clear && cartId === this.cart.cartId) {
                resolve(this.cart);
            } else {
                if(login !== undefined){
                    login = '&centroDeOperacion='+login;
                }else{
                    login = '';
                }
                this.$http({
                    method: 'GET',
                    url: url ? url : this.ngAuthSettings.apiServiceBaseUri + '/cart/obtener-canasta?cartId=' + cartId + '&userId=' + userId + '&quotePriceListName=' + clientPriceListName+'&origen=b2b'+login,
                    cache: false
                }).then((response) => {

                    if (!response.data.error) {
                        this.SessionService.put('cartId', response.data.cartId);
                        response.data.items = [];
                        response.data.order = {};
                        // Se actualiza la información del item almacenado
                        if (!response.data.itemsCanastaUsuario) response.data.itemsCanastaUsuario = [];
                        response.data.itemsCanastaUsuario.forEach(dato => {
                            response.data.items.push(dato);
                        });
                        response.data.cartQuantity = response.data.cartQuantity || 0;
                        response.data.cartTaxes = response.data.cartTaxes || 0;
                        response.data.cartSubtotal = response.data.cartSubtotal || 0;
                        response.data.cartTotal = response.data.cartTotal || 0;
                        response.data.cartDiscounts = response.data.cartDiscounts || 0;
                        response.data.cartTransports = response.data.cartTransports || 0;

                        response.data.order = response.data.cartOrderData || {};
                        response.data.order.cantidadTotalCanasta = 0;
                        response.data.order.vehiculo_transporte = {};
                        response.data.items.forEach(item => {
                            response.data.order.cantidadTotalCanasta += item.quantity;
                        });
                        response.data.tunnel = response.data.cartTunnelData || {};
                        // ===================================================================================================
                        // Load the values for the seller quoting
                        // ===================================================================================================
                        let quoteCartSeller = this.SessionService.get('quoteCartSeller') || null;

                        if (quoteCartSeller) {
                            let itemsQuoteCartSeller = quoteCartSeller.itemsQuoteCartSeller;
                            itemsQuoteCartSeller.forEach(itemSeller => {
                                response.data.items.forEach((item, key) => {
                                    if (item.id === itemSeller.id) {
                                        response.data.items[key].priceItemQuoteSeller = response.data.items[key].priceItemQuoteSeller || 0;
                                        response.data.items[key].ivaPercentageQuoteSeller = item.ivaPercentageQuoteSeller || 0;
                                        response.data.items[key].discountPercentageItemQuoteSeller = itemSeller.discountPercentageItemQuoteSeller || 0;
                                    }
                                });

                            });
                        }
                        this.cart = response.data;
                        resolve(response.data);
                    } else {
                        response.data.items = [];
                        response.data.order = {};
                        response.data.cartQuantity = response.data.cartQuantity || 0;
                        response.data.cartTaxes = response.data.cartTaxes || 0;
                        response.data.cartSubtotal = response.data.cartSubtotal || 0;
                        response.data.cartTotal = response.data.cartTotal || 0;
                        response.data.cartDiscounts = response.data.cartDiscounts || 0;
                        response.data.cartTransports = response.data.cartTransports || 0;
                        this.cart = response.data;
                        resolve(response.data);
                    }
                }).catch(reason => {
                    reject(reason);
                });
            }
        });
    }

    getCartNew(clear) {
        return this.$q((resolve, reject) => {
            let thirdId = this.SharedService.partialConsultThird();
            let userId = this.SharedService.partialConsultUser();
            if (this.cart.cartId && !clear) {
                resolve(this.cart);
            } else {
                let cartSaved = this.AuthTokenFactory.getToken('auth-cart');
                if (!cartSaved) return reject();
                let cart = atob(cartSaved);
                cart = cart.split(':')[0];
                this.$http({
                    method: 'GET',
                    url: this.ngAuthSettings.apiServiceBaseUri + '/cart/obtener-canasta?cartId=' + cart + '&userId=' + (thirdId ? thirdId : userId),
                    cache: false
                }).then((response) => {
                    response.data.id = cart;
                    this.cart = response.data;
                    resolve(response.data);
                }).catch(reason => {
                    reject(reason);
                });
            }
        });
    }

    getCartResumeData(cartId, userId, login = false, origin = 'b2b') {

        return this.$q((resolve, reject) => {
            let url = this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getResumeCart
                + '?cartId=' + cartId + '&userId=' + userId + '&origin=' + origin;

            if (login) {
                url += '&login=' + login;
            }
            this.$http({
                method: 'GET',
                url: url,
                cache: false
            }).then((response) => {

                if (!response.data.error) {

                    this.SessionService.put('cartId', response.data.cartId);
                    if(login){
                      this.SessionService.put('cartUnified', response.data.cartUnified);
                    }
                    response.data.items = [];

                    if (!response.data.itemsCanastaUsuario) {
                        response.data.itemsCanastaUsuario = [];
                    }

                    response.data.itemsCanastaUsuario.forEach(dato => {
                        response.data.items.push(dato);
                    });

                    response.data.cartQuantity = response.data.cartQuantity || 0;
                    this.cart = response.data;
                    resolve(response.data);
                } else {
                    response.data.items = [];
                    response.data.cartQuantity = response.data.cartQuantity || 0;
                    this.cart = response.data;
                    resolve(response.data);
                }
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    saveOrder(cartId, branchId, userId, contact, sellerOfCounter) {
        let data = {
            canastaId: cartId,
            sucursalId: branchId,
            usuarioVendedorId: userId,
            esVentaMostrador: sellerOfCounter
        };
        if (contact) {
            data.contactoNombre = contact.contactoNombre;
            data.contactoEmail = contact.contactoEmail;
            data.contactoTelefono = contact.contactoTelefono;
            data.contactoDireccion = contact.contactoDireccion;
            data.contactoNombreCiudad = contact.contactoNombreCiudad;
        }
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/pedidos/pedidos/crear-pedido',
                // url: this.ngAuthSettings.apiServiceBaseUri + '/pedidos/pedidos/crear-pedido?canastaId=' + cartId + '&sucursalId=' + branchId + '&usuarioVendedorId=' + userId,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                if (!response.data.error) {
                    resolve(response.data);
                } else {
                    reject(response.data.message);
                }
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    createCartTemplate(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.createCartTemplate,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateCityLocation(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updateCityLocation,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    deleteItemFromCart(itemId, cartId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/cart/eliminar-item-canasta',
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: $.param({
                    'id_canasta': cartId,
                    'id_producto': itemId,
                })
            }).then((response) => {
                if (!response.data.error) {
                    resolve(response.data);
                } else {
                    reject(response.data.message);
                }
            }).catch(reason => {
                reject(reason);
            });
        });
    }


    updateItemsNotAvailable(product, quantity, userId, cartId) {
        console.log(cartId);
        let data = {
            'userId': userId,
            'itemId': product.id,
            'cantDisp': product.cantidad,
            'cantSoli': quantity,
            'origen' : 'B2B',
            'cartId' : cartId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/item-info/registrar-venta-perdida',
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }


    clearLocalCart() {
        this.cart = null;
    }

    getMethodTransport(){

        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.locationRuler,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });


    }

    getQuantitiesBasketB2b(){
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getQuantitiesBasket,
                cache: false,
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }


    validateProductBySucursal(params){
      return this.$q((resolve, reject) => {
        this.$http({
            method: 'POST',
            url: this.ngAuthSettings.apiServiceBaseUri + '/cart/validar-productos-permitidos-sucursal',
            cache: false,
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            data: $.param(params)
        }).then((response) => {
                resolve(response.data);
        }).catch(reason => {
            reject(reason);
        });
    });
    }


    // Obtenemos la modalidad de envio
    getShippingMode(cartId) {

        let data = {
            'cartId': cartId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getModalidadEnvio,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);

            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getSecondaryBranch(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getSucursalesSecundarias,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {

                reject(reason);
            });
        });
    }

    getPrincipalBranchOffice(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getSucursalesPrincipales,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {

                reject(reason);
            });
        });
    }

    updateDateCart(cartId){
        let data = {
            'cartId': cartId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updateDateCart,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {

                reject(reason);
            });
        });
    }
    updatePromiseCart(cartId,sucursalId,ciudadId){
        let data = {
            'cartId': cartId,
            'idSucursal': sucursalId,
            'idCiudad' : ciudadId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updatePromiseCart,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {

                reject(reason);
            });
        });
    }

    getShippingModalities(){ 
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getModalidadesEntrega,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {

                reject(reason);
            });
        });
    }

    verifyBranchLock(sucursalId) {
        let data = {
            'sucursalId': sucursalId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.verificarBloqueoRetiroSucursal,
                cache: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateUnloadingService(cartId,unloadService){
        let data = {
            'cartId': cartId,
            'unloadService': unloadService
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.servicioDescargue,
                cache: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateOwnTransport(cartId,ownTransport){
        let data = {
            'cartId': cartId,
            'ownTransport': ownTransport
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.transportePropio,
                cache: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateUltracemTransport(cartId,ultracemTransport){
        let data = {
            'cartId': cartId,
            'ultracemTransport': ultracemTransport
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.transporteUltracem,
                cache: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateShippingMode(cartId,modalidadEnvioId){
        let data = {
            'cartId': cartId,
            'modalidadEnvioId': modalidadEnvioId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updateShippingMode,
                cache: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getDeliveryPromise(cartId){
        let data = {
            'cartId': cartId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getPromiseDelivery,
                cache: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    validateHoliday(idSucursal,fechaValidar){
        let data = {
            'idSucursal': idSucursal,
            'fechaValidar': fechaValidar
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.validateHoliday,
                cache: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    verifyUnloadingService(cartId){
        let data = {
            'cartId': cartId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.verifyUnloadingService,
                cache: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }
    
    updatePayConditionAuto(cartId){
        let data = {
            'cartId': cartId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updatePayConditionAuto,
                cache: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getDebtsToPay(data){
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.WALLET.DEBTS_TO_PAY +'?id_cia='+data.idCia+'&nit_tercero='+data.nit+'&id_sucursal='+data.idSucursal+'&id_moneda_docto='+data.moneda,
                cache: false,
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updatePayCondition(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updatePayCondition,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    createToken(email) {
        let data = {
            'email': email
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.createToken,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }
    
    checkVolumePurchaseRule(cartId) {
        let data = {
            'cartId': cartId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.verificarRegla,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    verifyServiceDownloadWarehouse(cartId) {
        let data = {
            'cartId': cartId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.verifyServiceDownloadWarehouse,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    verifyDaysFestivesBranchOfficePromise(cartId){
        let data = {
            'cartId': cartId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.verifyDaysFestivesBranchOfficePromise,
                cache: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }


    getMaximumMainVolume(cartId, userId){
        let data = {
            'cartId': cartId,
            'userId': userId
        };
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getMaximumMainVolume,
                cache: false,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    /**
        * Chequea todos los items de la canasta y elimina los items que no estan asociados a una lista de precios o,
        * que tengan precio = 0
        * @param cartId 
        * @param userId 
    */
    checkItemsPriceByCart(cartId, userId, clientPriceListName, clear, url, login) {
        
        return this.$q((resolve, reject) => {

            if(login !== undefined){
                login = '&centroDeOperacion='+login;
            }else{
                login = '';
            }

            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.checkItemsPriceByCart + '?cartId=' + cartId + '&userId=' + userId + '&quotePriceListName=' + clientPriceListName+'&origen=b2b' + login,
                cache: false
            })
            .then((response) => {
                resolve(response);
            })
            .catch(reason => {
                reject(reason);
            });
        });
    }
}

CartService.$inject = inject;

export default CartService;



/** WEBPACK FOOTER **
 ** ./www/components/cart/cart.service.js
 **/